$(function() {
  $('.QuantitySelector__Button').on('click', function() {
    let operator = $(this).attr('data-operator');
    let id = $(this).attr('data-id');
    let quantity_selector = '#current-quantity-' + id;
    let current_quantity = Number($(quantity_selector).val());
    let quantity = current_quantity;

    if (operator == 'decrease-quantity') {
      if (quantity > 0) {
        quantity = Number(current_quantity - 1);
      }
    } else {
      quantity = Number(current_quantity + 1);
    }

    $(quantity_selector).val(quantity);
  });
});